<template>
  <details class="simple" open>
    <summary>Tabla de Pronóstico Comercial</summary>

    <div class="mb-2 mt-3" style="max-width: 300px">
      <b-form-input v-model="filter" type="search" placeholder="Búsqueda rápida"></b-form-input>
    </div>

    <b-table
      :items="items"
      :fields="fields"
      :filter="filter"
      striped
      hover
      responsive
      show-empty
      empty-text="No hay datos disponibles"
      foot-clone
      foot-variant="dark"
    >
      <template #cell(comercial)="data">
        <strong>{{ data.item.comercial }}</strong>
      </template>

      <template #cell(pendientes)="data">
        {{ data.item.pendientes }}
      </template>

      <template #cell(caducadas)="data">
        {{ data.item.caducadas }}
      </template>

      <template #cell(arrPendiente)="data">
        {{ data.item.arrPendiente | euro }}
      </template>

      <template #cell(contribucionARR)="data"> {{ data.item.contribucionARR | fraction }} % </template>

      <template #cell(ultimaOferta)="data">
        {{ data.item.ultimaOferta | dateEs }}
      </template>

      <!-- Footer con el resumen -->
      <template #foot(comercial)>
        <strong>{{ totalFilas }} Filas</strong>
      </template>

      <template #foot(pendientes)>
        <span class="item-resumen">{{ totalPendientes }} Pendientes</span>
      </template>

      <template #foot(promedioDiasGestion)>
        <span class="item-resumen">{{ promedioDiasGestion | fraction }} Días</span>
      </template>

      <template #foot(arrPendiente)>
        <span class="item-resumen">{{ totalARR | euro }}</span>
      </template>

      <template #foot(ultimaVenta)>
        <span class="item-resumen">{{ ultimaVentaGlobal | dateEs }}</span>
      </template>
    </b-table>
  </details>
</template>

<script>
export default {
  name: "TablaAnalisisComercial",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    totalFilas() {
      return this.items.length;
    },
    totalPendientes() {
      return this.items.reduce((sum, item) => sum + item.pendientes, 0);
    },
    promedioDiasGestion() {
      if (this.items.length === 0) return 0;
      const totalDias = this.items.reduce((sum, item) => sum + item.promedioDiasGestion, 0);
      return totalDias / this.items.length;
    },
    totalARR() {
      return this.items.reduce((sum, item) => sum + item.arrPendiente, 0);
    },
    ultimaVentaGlobal() {
      if (this.items.length === 0) return null;
      return this.items.reduce((latest, item) => {
        const itemDate = new Date(item.ultimaVenta);
        return itemDate > new Date(latest) ? item.ultimaVenta : latest;
      }, this.items[0].ultimaVenta);
    },
  },

  data() {
    return {
      filter: "",
      fields: [
        {
          key: "comercial",
          label: "Comercial",
          sortable: true,
        },
        {
          key: "pendientes",
          label: "Pendientes",
          sortable: true,
          class: "text-center",
        },
        {
          key: "caducadas",
          label: "Caducadas",
          sortable: true,
          class: "text-center",
        },
        {
          key: "promedioDiasGestion",
          label: "Días Gestión",
          sortable: true,
          class: "text-center",
        },
        {
          key: "arrPendiente",
          label: "Importe",
          sortable: true,
          class: "text-right",
        },
        {
          key: "contribucionARR",
          label: "Contribución",
          sortable: true,
          class: "text-right",
        },
        {
          key: "ultimaOferta",
          label: "Última oferta",
          sortable: true,
          class: "text-right",
        },
      ],
    };
  },

  methods: {
    getProductividadVariant(productividad) {
      if (productividad >= 10) return "success";
      if (productividad >= 5) return "warning";
      return "danger";
    },
  },
};
</script>

<style scoped>
.tabla-analisis-comercial {
  margin-top: 1rem;
}
.item-resumen {
  font-weight: bold;
}
</style>
